/**
 * @file   src\mobile\components\Common\HeaderMenu.js
 * @brief  This file is responsible for heade section in home page
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { pageURLs } from "../../../constants/pageURLs";
import { useNavigate } from "react-router-dom";
import GitchaLogoMobile from "../../images/gitchaLogomobile.svg";
import { getLocalStorage, getUserType } from "../../../helpers/common";
import { USER_INFO_KEY, USER_TYPE_AGENT } from "../../../constants/common";
import { useSelector } from "react-redux";
import MessageMenu from "../../components/messageMenu";

const HeaderMenu = (props) => {
  const { setSearchView, isFrom, isPremiumUser, redirectToHomePage } = props;

  let { unreadInappNotificationCount } = useSelector(
    (state) => state.unreadCount,
  );
  unreadInappNotificationCount = unreadInappNotificationCount?.payload;
  const { messageCount } = useSelector((state) => state.unreadCount);

  const navigate = useNavigate();
  const userDetails = getLocalStorage(USER_INFO_KEY);
  let userName = _.get(userDetails, "userInfo.name", null);
  let profileImage = _.get(userDetails, "userInfo.image", null);
  const userType = getUserType();

  if (userName) {
    userName = userName.replace(/-/g, "").match(/\b(\w)/g);
  }
  return (
    <>
      <div className="top-three-comp-header w-100 flex-column top-three-custom-pad custom">
        <div className="top-three-comp-header-inner w-100">
          <div className="p-0 toplinks-mobile top-three-equal-width">
            <div
              className="topbar-links message-icon-header position-relative"
              onClick={(e) => {
                navigate(pageURLs.mobileMessages);
                e.stopPropagation();
              }}
            >
              <MessageMenu unReadChatMessagesCount={messageCount} />
            </div>
          </div>
          <div
            className="p-0 top-three-equal-width logo-wrap text-center"
            role="button"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate(pageURLs.mobileHome);
              if (isFrom == "Home") {
                setSearchView(false);
                redirectToHomePage();
              }
            }}
            onKeyDown={() => {
              navigate(pageURLs.mobileHome);
              if (isFrom == "Home") {
                setSearchView(false);
                redirectToHomePage();
              }
            }}
          >
            <img src={GitchaLogoMobile} alt={GitchaLogoMobile} />
            <div className="bottom-mobile-tagline">
              {userType == USER_TYPE_AGENT ? (
                <>
                  The Buyer Listing Service<sup>®</sup>
                </>
              ) : (
                "The “Want” Marketplace for Real Estate"
              )}
            </div>
          </div>
          <div className="p-0 toplinks-mobile top-three-equal-width text-end">
            {userName ? (
              profileImage && userType == USER_TYPE_AGENT && isPremiumUser ? (
                <>
                  <figure
                    className="brdr-rs-200 profile-image-figure"
                    onClick={() => navigate(pageURLs.mobileSettings)}
                    role="button"
                  >
                    <img
                      className="brdr-rs-200"
                      src={profileImage + "?" + Math.random().toString(36)}
                      alt=""
                    />
                  </figure>
                </>
              ) : (
                <div
                  className="profile-user-info profile-bg-meroon ms-auto"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(pageURLs.mobileSettings)}
                  onKeyDown={() => navigate(pageURLs.mobileSettings)}
                  role="button"
                >
                  {userName}
                </div>
              )
            ) : (
              <button
                variant=""
                className="btn signin-btn-small"
                onClick={() => navigate(pageURLs.mobileSignIn)}
              >
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default HeaderMenu;
